<div #container class="ocl-container-with-padding">
  <div #controls style="margin-bottom: 16px">
    <app-loading-header>{{ label }}</app-loading-header>
    <div fxLayout="row" fxLayoutAlign="space-between">
      <dx-text-box
        class="uppercase"
        #textSelector
        [placeholder]="textSelectorPlaceholder"
        [disabled]="disabled"
        (onEnterKey)="pickerEnterKeyEvent()"
      ></dx-text-box>
      <div class="button-group">
        <!--<dx-tooltip target="#addBtn-{{controlName}}" showEvent="dxhoverstart" hideEvent="dxhoverend">
            <div *dxTemplate="let data of 'content'">
                <p>Add</p>
            </div>
        </dx-tooltip>--><!--
                <dx-tooltip target="#removeBtn-{{controlName}}" showEvent="dxhoverstart" hideEvent="dxhoverend">
                    <div *dxTemplate="let data of 'content'">
                        <p>Remove</p>
                    </div>
                </dx-tooltip>-->
        <!--<dx-tooltip target="#searchBtn-{{controlName}}" showEvent="dxhoverstart" hideEvent="dxhoverend">
            <div *dxTemplate="let data of 'content'">
                <p>Search</p>
            </div>
        </dx-tooltip>-->
        <dx-button
          id="addBtn-{{controlName}}"
          [disabled]="textSelector.text === ''"
          [icon]="'add'"
          title="Add"
          hint='Add'
          style="margin-right: 4px;margin-left: 4px;"
          (click)="pickerEnterKeyEvent()"
        ></dx-button>
        <dx-button
          id="removeBtn-{{controlName}}"
          [icon]="'trash'"
          title="Remove"
          hint='Remove'
          style="margin-right: 4px;"
          [disabled]="!IsSelected"
          (click)="removeItem()"
        ></dx-button>
        <dx-button
          id="searchBtn-{{controlName}}"
          [disabled]="disabled"
          [icon]="'search'"
          title="Search"
          hint='Search'
          style="margin-right: 4px;"
          (click)="search(false)"
        ></dx-button>
        <ng-template [ngIf]="optionalConfig">
          <!-- <dx-tooltip target="#optionalBtn-{{controlName}}" showEvent="dxhoverstart"
                       hideEvent="dxhoverend">
               <div *dxTemplate="let data of 'content'">
                   <p>{{ optionalConfig.button.text }}</p>
               </div>
           </dx-tooltip>-->
          <dx-button
            id="optionalBtn-{{controlName}}"
            [disabled]="!formRelation.dataSource || optionalConfig.button.disabled"
            [icon]="optionalConfig.button.icon"
            title="User"
            [hint]='optionalConfig.button.text'
            style="margin-right: 4px;"
            (click)="search(true)"
          ></dx-button>
        </ng-template>
      </div>
    </div>
  </div>
  <dx-data-grid
    #grid
    [height]="gridHeight"
    [keyExpr]="keyExpr"
    [dataSource]="currentDataSource"
    [columns]="columns"
    [showBorders]="true"
    [showColumnLines]="true"
    [showRowLines]="true"
    [hoverStateEnabled]="true"
    [(selectedRowKeys)]='selectedRowKeys'
    [selection]="{mode: 'multiple', allowSelectAll: false}"
    [allowColumnResizing]="true"
    [loadPanel]="{enabled: true}"
    (onContentReady)="refresh()"
    [paging]="{ enabled: true }"
  >
    <dxo-remote-operations [sorting]="true" [summary]="true" [filtering]="true"
                           [paging]="false"></dxo-remote-operations>
  </dx-data-grid>
</div>
<app-form-relation-selector
  #formRelation
  [title]="FormRelationTitle"
  [columns]="columns"
  [keyExpr]="keyExpr"
  [truncatedMode]="truncated"
  [dataSource]="dataSource"
  [alternateDataSource]="alternateDataSource"
  [control]="control"
  [popupVisible]="isPopupVisible"
  (closeEvent)="closeDialog($event)"
></app-form-relation-selector>
